import { apiService } from "../../ApiService";

export const resetEmail = (token: string) => {
  return apiService.request<unknown>({
    method: "post",
    path: `public/account/reset_email`,
    crm: true,
    body: {
      token,
    },
  });
};
